import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router'
import { finalize, of, switchMap } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { LoadingOverlay } from '@features/loading-overlay/loading-overlay.service'
import { APP_ROUTE_NAMES } from '@app/app.routes'
import { VerificationService } from '@features/verification/verification.service'
import { AuthService } from '@features/auth/auth.service'

export const eparakstsAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router)
  const navigate = (command: APP_ROUTE_NAMES) => router.createUrlTree(
      ['/', command],
  )

  const overlay = inject(LoadingOverlay)
  const verification = inject(VerificationService)
  const auth = inject(AuthService)

  const verificationId = route.queryParamMap.get('state')
  const code = route.queryParamMap.get('code')
  const error = route.queryParamMap.get('error')

  if (error) {
    return navigate(APP_ROUTE_NAMES.LOGIN)
  }

  if (!code || !verificationId) {
      return true
  }

  overlay.show()

  return verification
    .verify(verificationId, {code})
    .pipe(
      switchMap(verification =>
          auth.authByVerification(verification)
              .pipe(
                switchMap(() => of(true)),
                catchError(() => of(false)
              ),
          )
      ),
      switchMap(success => of(navigate(success ? APP_ROUTE_NAMES.FLOW : APP_ROUTE_NAMES.LOGIN))),
      catchError(() => of(navigate(APP_ROUTE_NAMES.LOGIN))),
      finalize(() => overlay.hide()),
    )
}
